import React from 'react';
import type { PurchaseOrderStatus } from '@lognai/plugin-orders';
import { Badge } from '@lognai/synapse-design-system-v2';
import type { BadgeProps } from '@lognai/synapse-design-system-v2';
import { ExplainIcon } from '@lognai/plugin-ai-core-ui';
import { formatPurchaseOrderStatus } from '../../utils/format';

interface PurchaseOrderStatusBadgeProps {
  status: PurchaseOrderStatus;
  poId?: string;
}

type Tone = NonNullable<BadgeProps['tone']>;

const statusTone: Record<PurchaseOrderStatus, Tone> = {
  draft:              'neutral',
  submitted:          'warning',
  confirmed:          'info',
  partially_received: 'warning',
  received:           'success',
  cancelled:          'neutral',
};

export const PurchaseOrderStatusBadge: React.FC<PurchaseOrderStatusBadgeProps> = ({
  status,
  poId,
}) => {
  return (
    <span className="inline-flex items-center gap-1">
      <Badge tone={statusTone[status]}>
        {formatPurchaseOrderStatus(status)}
      </Badge>
      {poId && (
        <ExplainIcon
          pluginId="orders"
          entityType="purchaseOrder"
          entityId={poId}
          field="status"
          ariaLabel={`Explain PO status ${poId}`}
        />
      )}
    </span>
  );
};
